/* Maps city/state names (lowercase) to their 2-digit GSTIN state codes. */
export const PLACE_TO_STATE_CODE = {
  // States / UTs
  'jammu and kashmir': '01', 'j&k': '01',
  'himachal pradesh': '02',
  'punjab': '03',
  'chandigarh': '04',
  'uttarakhand': '05', 'uttaranchal': '05',
  'haryana': '06',
  'delhi': '07', 'new delhi': '07',
  'rajasthan': '08',
  'uttar pradesh': '09',
  'bihar': '10',
  'sikkim': '11',
  'arunachal pradesh': '12',
  'nagaland': '13',
  'manipur': '14',
  'mizoram': '15',
  'tripura': '16',
  'meghalaya': '17',
  'assam': '18',
  'west bengal': '19',
  'jharkhand': '20',
  'odisha': '21', 'orissa': '21',
  'chhattisgarh': '22',
  'madhya pradesh': '23',
  'gujarat': '24',
  'maharashtra': '27',
  'karnataka': '29',
  'goa': '30',
  'lakshadweep': '31',
  'kerala': '32',
  'tamil nadu': '33',
  'puducherry': '34', 'pondicherry': '34',
  'andaman and nicobar': '35',
  'telangana': '36',
  'andhra pradesh': '37',
  'ladakh': '38',
  // Haryana cities / districts
  'sonipat': '06', 'sonepat': '06',
  'gurgaon': '06', 'gurugram': '06',
  'faridabad': '06',
  'rohtak': '06',
  'ambala': '06',
  'panipat': '06',
  'karnal': '06',
  'hisar': '06',
  'sirsa': '06',
  'rewari': '06',
  'panchkula': '06',
  'bhiwani': '06',
  'yamunanagar': '06',
  'kurukshetra': '06',
  'kaithal': '06',
  'jind': '06',
  'fatehabad': '06',
  'jhajjar': '06',
  'bahadurgarh': '06',
  'nuh': '06', 'mewat': '06',
  'palwal': '06',
  'mahendragarh': '06',
  // Major UP cities
  'noida': '09', 'greater noida': '09', 'ghaziabad': '09',
  'agra': '09', 'lucknow': '09', 'varanasi': '09',
  'kanpur': '09', 'prayagraj': '09', 'allahabad': '09', 'meerut': '09',
  // Rajasthan cities
  'jaipur': '08', 'jodhpur': '08', 'udaipur': '08', 'kota': '08', 'ajmer': '08',
  // Maharashtra cities
  'mumbai': '27', 'pune': '27', 'nagpur': '27', 'nashik': '27',
  // Karnataka cities
  'bangalore': '29', 'bengaluru': '29', 'mysuru': '29', 'mysore': '29',
  // Tamil Nadu cities
  'chennai': '33', 'coimbatore': '33', 'madurai': '33',
  // Gujarat cities
  'ahmedabad': '24', 'surat': '24', 'vadodara': '24',
  // West Bengal cities
  'kolkata': '19', 'calcutta': '19',
  // Telangana cities
  'hyderabad': '36',
  // Kerala cities
  'kochi': '32', 'thiruvananthapuram': '32', 'trivandrum': '32',
  // Andhra Pradesh cities
  'visakhapatnam': '37', 'vizag': '37', 'vijayawada': '37',
  // Uttarakhand cities
  'dehradun': '05', 'haridwar': '05',
  // Punjab cities
  'ludhiana': '03', 'amritsar': '03', 'jalandhar': '03',
  // Madhya Pradesh cities
  'bhopal': '23', 'indore': '23',
  // Bihar cities
  'patna': '10',
  // Assam cities
  'guwahati': '18',
  // Jharkhand cities
  'ranchi': '20',
  // Odisha cities
  'bhubaneswar': '21',
  // Chhattisgarh cities
  'raipur': '22',
  // Himachal Pradesh cities
  'shimla': '02', 'manali': '02',
};

export const getStateCodeFromGstin = gstin =>
  gstin?.length >= 2 ? gstin.substring(0, 2) : null;

export const getStateCodeFromPlace = place => {
  if (!place) return null;
  const lower = place.toLowerCase().trim();
  if (PLACE_TO_STATE_CODE[lower]) return PLACE_TO_STATE_CODE[lower];
  for (const [key, code] of Object.entries(PLACE_TO_STATE_CODE)) {
    if (lower.includes(key)) return code;
  }
  return null;
};

export const isIntrastate = (firmGstin, placeOfSupply) => {
  const firmCode   = getStateCodeFromGstin(firmGstin);
  const supplyCode = getStateCodeFromPlace(placeOfSupply);
  return !!(firmCode && supplyCode && firmCode === supplyCode);
};
